import { render, staticRenderFns } from "./ClaimFacts.vue?vue&type=template&id=00fc8c5a"
import script from "./ClaimFacts.vue?vue&type=script&lang=js"
export * from "./ClaimFacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports